/**
 * Actions for Create Schema
 */
export enum createSourceRegistry {
  CREATE_SOURCE_REGISTRY_REQUEST = 'CREATE_SOURCE_REGISTRY_REQUEST'
}
